import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Dayjs } from "utils/dayjs"

import NoValue from "components/NoValue/NoValue"
import { ErpInvoiceStatus } from "models/OutgoingInvoice"
import ErpValue from "./ErpValue"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"

interface IErpInvoiceDateProps {
    invoiceDate?: Dayjs | null
    invoiceDateStatus?: ErpInvoiceStatus
    isInvoiceERPInterfaceConnected?: boolean
    longError?: boolean
    isItalic?: boolean
    isRedText?: boolean
}

const ErpInvoiceDate: FC<IErpInvoiceDateProps> = ({
    invoiceDate,
    invoiceDateStatus,
    isInvoiceERPInterfaceConnected,
    longError,
    isItalic,
    isRedText,
}) => {
    const { t } = useTranslation()
    const notApplicable = <NoValue>
        <FlexibleContent text={t("common.notApplicable")} />
    </NoValue>

    if (!!invoiceDate) {
        return <div className={isRedText ? "color-red-500" : ""}>{invoiceDate.format(t("config.dateLongFormat"))}</div>
    }

    if (isInvoiceERPInterfaceConnected && !invoiceDateStatus) {
        return notApplicable
    }

    switch (invoiceDateStatus) {
        case ErpInvoiceStatus.pending:
            return <ErpValue isItalic={isItalic} text={t("common.pending")} />
        case ErpInvoiceStatus.error:
            return <ErpValue isInvalid isItalic={isItalic} text={longError ? t("outgoingInvoices.retrievingInvoiceDateFailed") : t("common.failure")} />
        default:
            return notApplicable
    }
}

export default ErpInvoiceDate
